import { shopPrefix } from '../../../config';
import { SelectionListCommentOut } from '../../../store/api';
import { http } from '../../../api/axios';

const url = `${shopPrefix}/v1/selectionlists/:listId/comments`;
export const fetchComments = (listId: string, pageNum = 0, lastCommentId: number) => {
    const params = {};
    if (pageNum) {
        params['startId'] = lastCommentId;
    }
    return http
        .get<SelectionListCommentOut[]>(url, {
            params,
            pathParams: { listId }
        })
        .then(response => {
            return { comments: response.data, pageNum };
        });
};
